var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootballFieldMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "548px",
    height: "406px",
    viewBox: "0 0 548 406",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "292BAD7B-DF25-4253-B71F-C7C67E03FCB9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Set-Strategy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Strategy-Final-|-Initial-(Mobile)",
    transform: "translate(92.000000, -283.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-67",
    transform: "translate(-92.000000, 283.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pitch"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7304908,404.953344 L21.64535,404.953344 L26.8583663,384.88447 C33.0878673,391.95345 39.7231012,398.654378 46.7304908,404.953344 L46.7304908,404.953344 Z",
    id: "Path",
    fill: "#00B259",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.593419,398.934681 L459.49205,27.8904688 L99.3072927,27.8904688 L92.5210389,53.6247501 L0,404.953344 L164.143349,404.953344 L382.796716,404.953344 L548,404.953344 L546.593419,398.934681 Z M250.104787,71.9406798 L250.104787,71.8407021 C250.104787,71.7073984 250.104787,71.5807598 250.104787,71.4541213 L299.081808,71.4541213 C299.081808,71.5807598 299.081808,71.7073984 299.081808,71.8407021 C299.081808,71.9740058 299.081808,72.0673184 299.081808,72.1806265 C298.961787,76.3678172 297.411453,80.3876881 294.688742,83.5714286 C290.26901,88.903577 282.916124,92.3628083 274.59663,92.3628083 C266.277136,92.3628083 258.790925,88.8169296 254.384526,83.4247945 C251.674659,80.2055823 250.162512,76.1479362 250.104787,71.9406798 L250.104787,71.9406798 Z M108.646725,43.7869362 L124.05912,43.7869362 C121.845922,51.4185737 114.246384,57.1173073 105.140271,57.2839369 L108.646725,43.7869362 Z",
    id: "Shape",
    fill: "#00B259",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.627602,404.953344 L506.055885,404.953344 C513.682558,398.10181 520.880177,390.787379 527.607907,383.051544 L532.627602,404.953344 Z",
    id: "Path",
    fill: "#00B259",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00A653",
    fillRule: "nonzero",
    opacity: 0.5,
    points: "397.535819 404.880027 481.03074 404.880027 406.035302 27.970451 357.458257 27.970451"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00A653",
    fillRule: "nonzero",
    opacity: 0.5,
    points: "154.017298 405 70.522377 405 145.517815 28.0904244 194.09486 28.0904244"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#00B259",
    strokeWidth: 3,
    points: "498.243027 255.71984 498.23636 255.71984 498.083036 255.71984"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.7633964,
    y1: 253.533659,
    x2: 53.5767411,
    y2: 253.533659,
    id: "Path",
    stroke: "#00B259",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00B259",
    fillRule: "nonzero",
    points: "484.063889 194.486781 484.063889 194.47345 484.070555 194.493446"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-66",
    transform: "translate(14.445788, 57.237281)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "90.3011739 0 89.2612372 4.00577649 76.6353385 52.6216396 60.1163433 116.214175 39.3176084 196.296379 34.5712305 214.565652 28.8382458 236.634081 12.4592421 299.700067 5.41300408 326.840702 0 347.669407"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.665811,43.7402799 C121.452612,51.3719174 113.853075,57.070651 104.746962,57.2372806 L108.22675,43.7402799 L123.665811,43.7402799 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#00B259",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.393638,43.7402799 C435.606837,51.3719174 443.206374,57.070651 452.312487,57.2372806 L448.806034,43.7402799 L433.393638,43.7402799 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#00B259",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00A653",
    fillRule: "nonzero",
    opacity: 0.5,
    points: "229.706028 404.81676 318.749749 404.81676 304.674801 27.6438569 246.565002 27.6438569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.186643,254.420129 C329.186643,254.686736 329.186643,254.946679 329.186643,255.199956 C328.700006,280.600978 303.98151,301.056432 273.556694,301.056432 C242.891892,301.056432 218.053403,280.301044 217.913412,254.646745 C217.913412,254.573428 217.913412,254.493446 217.913412,254.420129 C217.913412,228.672517 242.831896,207.76383 273.56336,207.76383 C304.294824,207.76383 329.186643,228.672517 329.186643,254.420129 Z",
    id: "Path",
    stroke: "#FCFCFC",
    strokeWidth: 2,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 273.536695,
    cy: 253.506998,
    rx: 5.3063439,
    ry: 3.99911131
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    points: "355.518375 43.6669629 355.531707 43.7402799 358.458196 64.8155965 359.371474 71.407465 298.688498 71.407465"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.718144,
    y1: 71.407465,
    x2: 298.688498,
    y2: 71.407465,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    points: "234.37241 44.3801377 234.37241 55.2710509 314.027565 55.2710509 314.027565 44.3801377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.695165,71.7940458 C298.695165,71.9073539 298.695165,72.0206621 298.695165,72.1339702 C298.575144,76.3211609 297.024809,80.3410318 294.302098,83.5247723 C289.882367,88.8569207 282.529481,92.316152 274.209987,92.316152 C265.890493,92.316152 258.404282,88.7702733 253.997883,83.3781382 C251.288016,80.158926 249.775869,76.1012799 249.718144,71.8940236 L249.718144,71.7940458 C249.718144,71.6607421 249.718144,71.5341035 249.718144,71.407465 L298.688498,71.407465 C298.695165,71.5341035 298.695165,71.6607421 298.695165,71.7940458 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#00A653",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    points: "249.718144 71.407465 189.028502 71.407465 190.028441 64.2157298 192.868268 43.7402799 192.881601 43.6669629"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    points: "123.665811 43.7402799 144.364552 43.7402799 192.868268 43.7402799 355.531707 43.7402799 401.788894 43.7402799 449.559321 43.7402799 455.132316 68.0948678 466.78494 119.003555 476.770999 162.627194 484.063889 194.47345 484.063889 194.486781 484.070555 194.493446 497.583067 253.533659 498.083036 255.71984 498.229694 256.353033 515.588638 332.182848 527.221264 383.004888 532.227626 404.880027 532.234292 404.906687"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    points: "237.318898 43.1137525 237.318898 16.5729838 310.161134 16.5729838 310.161134 43.1137525"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "241.158664 18.8991335 239.425436 19.7989336 237.77887 18.7591646 237.858865 16.8062653 239.592093 15.9064652 241.238659 16.9462342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "244.491795 18.8991335 242.758567 19.7989336 241.112 18.7591646 241.191996 16.8062653 242.925224 15.9064652 244.57179 16.9462342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "247.824925 18.8991335 246.091698 19.7989336 244.445131 18.7591646 244.525126 16.8062653 246.258354 15.9064652 247.904921 16.9462342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "251.158056 18.8991335 249.424828 19.7989336 247.778262 18.7591646 247.858257 16.8062653 249.591485 15.9064652 251.238051 16.9462342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "254.491187 18.8991335 252.757959 19.7989336 251.111392 18.7591646 251.191387 16.8062653 252.924615 15.9064652 254.571182 16.9462342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "257.824317 18.8991335 256.091089 19.7989336 254.444523 18.7591646 254.524518 16.8062653 256.257746 15.9064652 257.904312 16.9462342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "261.157448 18.8991335 259.42422 19.7989336 257.777653 18.7591646 257.857649 16.8062653 259.590876 15.9064652 261.237443 16.9462342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "264.490578 18.8991335 262.757351 19.7989336 261.110784 18.7591646 261.190779 16.8062653 262.924007 15.9064652 264.570574 16.9462342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "267.823709 18.8991335 266.090481 19.7989336 264.443915 18.7591646 264.52391 16.8062653 266.257138 15.9064652 267.903704 16.9462342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "271.15684 18.8991335 269.423612 19.7989336 267.777045 18.7591646 267.85704 16.8062653 269.590268 15.9064652 271.236835 16.9462342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "274.48997 18.8991335 272.756742 19.7989336 271.110176 18.7591646 271.190171 16.8062653 272.923399 15.9064652 274.569965 16.9462342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "277.823101 18.8991335 276.089873 19.7989336 274.443306 18.7591646 274.523302 16.8062653 276.256529 15.9064652 277.903096 16.9462342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "281.156231 18.8991335 279.423003 19.7989336 277.776437 18.7591646 277.856432 16.8062653 279.58966 15.9064652 281.236227 16.9462342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "284.489362 18.8991335 282.756134 19.7989336 281.109568 18.7591646 281.189563 16.8062653 282.922791 15.9064652 284.569357 16.9462342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "287.822493 18.8991335 286.089265 19.7989336 284.442698 18.7591646 284.522693 16.8062653 286.255921 15.9064652 287.902488 16.9462342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "291.155623 18.8991335 289.422395 19.7989336 287.775829 18.7591646 287.855824 16.8062653 289.589052 15.9064652 291.235618 16.9462342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "294.488754 18.8991335 292.755526 19.7989336 291.108959 18.7591646 291.188954 16.8062653 292.922182 15.9064652 294.568749 16.9462342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "297.821884 18.8991335 296.088656 19.7989336 294.44209 18.7591646 294.522085 16.8062653 296.255313 15.9064652 297.901879 16.9462342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "301.155015 18.8991335 299.421787 19.7989336 297.77522 18.7591646 297.855216 16.8062653 299.588444 15.9064652 301.23501 16.9462342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "304.488145 18.8991335 302.754918 19.7989336 301.108351 18.7591646 301.188346 16.8062653 302.921574 15.9064652 304.568141 16.9462342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "307.821276 18.8991335 306.088048 19.7989336 304.441482 18.7591646 304.521477 16.8062653 306.254705 15.9064652 307.901271 16.9462342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "310.627772 19.1724061 309.421179 19.7989336 307.774612 18.7591646 307.854607 16.8062653 309.587835 15.9064652 310.627772 16.5663186"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "241.158664 22.8982448 239.425436 23.7980449 237.77887 22.7582759 237.858865 20.8053766 239.592093 19.9055765 241.238659 20.9453455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "244.491795 22.8982448 242.758567 23.7980449 241.112 22.7582759 241.191996 20.8053766 242.925224 19.9055765 244.57179 20.9453455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "247.824925 22.8982448 246.091698 23.7980449 244.445131 22.7582759 244.525126 20.8053766 246.258354 19.9055765 247.904921 20.9453455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "251.158056 22.8982448 249.424828 23.7980449 247.778262 22.7582759 247.858257 20.8053766 249.591485 19.9055765 251.238051 20.9453455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "254.491187 22.8982448 252.757959 23.7980449 251.111392 22.7582759 251.191387 20.8053766 252.924615 19.9055765 254.571182 20.9453455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "257.824317 22.8982448 256.091089 23.7980449 254.444523 22.7582759 254.524518 20.8053766 256.257746 19.9055765 257.904312 20.9453455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "261.157448 22.8982448 259.42422 23.7980449 257.777653 22.7582759 257.857649 20.8053766 259.590876 19.9055765 261.237443 20.9453455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "264.490578 22.8982448 262.757351 23.7980449 261.110784 22.7582759 261.190779 20.8053766 262.924007 19.9055765 264.570574 20.9453455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "267.823709 22.8982448 266.090481 23.7980449 264.443915 22.7582759 264.52391 20.8053766 266.257138 19.9055765 267.903704 20.9453455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "271.15684 22.8982448 269.423612 23.7980449 267.777045 22.7582759 267.85704 20.8053766 269.590268 19.9055765 271.236835 20.9453455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "274.48997 22.8982448 272.756742 23.7980449 271.110176 22.7582759 271.190171 20.8053766 272.923399 19.9055765 274.569965 20.9453455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "277.823101 22.8982448 276.089873 23.7980449 274.443306 22.7582759 274.523302 20.8053766 276.256529 19.9055765 277.903096 20.9453455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "281.156231 22.8982448 279.423003 23.7980449 277.776437 22.7582759 277.856432 20.8053766 279.58966 19.9055765 281.236227 20.9453455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "284.489362 22.8982448 282.756134 23.7980449 281.109568 22.7582759 281.189563 20.8053766 282.922791 19.9055765 284.569357 20.9453455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "287.822493 22.8982448 286.089265 23.7980449 284.442698 22.7582759 284.522693 20.8053766 286.255921 19.9055765 287.902488 20.9453455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "291.155623 22.8982448 289.422395 23.7980449 287.775829 22.7582759 287.855824 20.8053766 289.589052 19.9055765 291.235618 20.9453455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "294.488754 22.8982448 292.755526 23.7980449 291.108959 22.7582759 291.188954 20.8053766 292.922182 19.9055765 294.568749 20.9453455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "297.821884 22.8982448 296.088656 23.7980449 294.44209 22.7582759 294.522085 20.8053766 296.255313 19.9055765 297.901879 20.9453455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "301.155015 22.8982448 299.421787 23.7980449 297.77522 22.7582759 297.855216 20.8053766 299.588444 19.9055765 301.23501 20.9453455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "304.488145 22.8982448 302.754918 23.7980449 301.108351 22.7582759 301.188346 20.8053766 302.921574 19.9055765 304.568141 20.9453455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "307.821276 22.8982448 306.088048 23.7980449 304.441482 22.7582759 304.521477 20.8053766 306.254705 19.9055765 307.901271 20.9453455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "310.627772 23.1715174 309.421179 23.7980449 307.774612 22.7582759 307.854607 20.8053766 309.587835 19.9055765 310.627772 20.5654299"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "241.158664 26.8973561 239.425436 27.7971562 237.77887 26.7573872 237.858865 24.8044879 239.592093 23.9046878 241.238659 24.9444568"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "244.491795 26.8973561 242.758567 27.7971562 241.112 26.7573872 241.191996 24.8044879 242.925224 23.9046878 244.57179 24.9444568"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "247.824925 26.8973561 246.091698 27.7971562 244.445131 26.7573872 244.525126 24.8044879 246.258354 23.9046878 247.904921 24.9444568"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "251.158056 26.8973561 249.424828 27.7971562 247.778262 26.7573872 247.858257 24.8044879 249.591485 23.9046878 251.238051 24.9444568"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "254.491187 26.8973561 252.757959 27.7971562 251.111392 26.7573872 251.191387 24.8044879 252.924615 23.9046878 254.571182 24.9444568"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "257.824317 26.8973561 256.091089 27.7971562 254.444523 26.7573872 254.524518 24.8044879 256.257746 23.9046878 257.904312 24.9444568"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "261.157448 26.8973561 259.42422 27.7971562 257.777653 26.7573872 257.857649 24.8044879 259.590876 23.9046878 261.237443 24.9444568"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "264.490578 26.8973561 262.757351 27.7971562 261.110784 26.7573872 261.190779 24.8044879 262.924007 23.9046878 264.570574 24.9444568"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "267.823709 26.8973561 266.090481 27.7971562 264.443915 26.7573872 264.52391 24.8044879 266.257138 23.9046878 267.903704 24.9444568"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "271.15684 26.8973561 269.423612 27.7971562 267.777045 26.7573872 267.85704 24.8044879 269.590268 23.9046878 271.236835 24.9444568"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "274.48997 26.8973561 272.756742 27.7971562 271.110176 26.7573872 271.190171 24.8044879 272.923399 23.9046878 274.569965 24.9444568"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "277.823101 26.8973561 276.089873 27.7971562 274.443306 26.7573872 274.523302 24.8044879 276.256529 23.9046878 277.903096 24.9444568"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "281.156231 26.8973561 279.423003 27.7971562 277.776437 26.7573872 277.856432 24.8044879 279.58966 23.9046878 281.236227 24.9444568"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "284.489362 26.8973561 282.756134 27.7971562 281.109568 26.7573872 281.189563 24.8044879 282.922791 23.9046878 284.569357 24.9444568"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "287.822493 26.8973561 286.089265 27.7971562 284.442698 26.7573872 284.522693 24.8044879 286.255921 23.9046878 287.902488 24.9444568"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "291.155623 26.8973561 289.422395 27.7971562 287.775829 26.7573872 287.855824 24.8044879 289.589052 23.9046878 291.235618 24.9444568"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "294.488754 26.8973561 292.755526 27.7971562 291.108959 26.7573872 291.188954 24.8044879 292.922182 23.9046878 294.568749 24.9444568"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "297.821884 26.8973561 296.088656 27.7971562 294.44209 26.7573872 294.522085 24.8044879 296.255313 23.9046878 297.901879 24.9444568"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "301.155015 26.8973561 299.421787 27.7971562 297.77522 26.7573872 297.855216 24.8044879 299.588444 23.9046878 301.23501 24.9444568"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "304.488145 26.8973561 302.754918 27.7971562 301.108351 26.7573872 301.188346 24.8044879 302.921574 23.9046878 304.568141 24.9444568"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "307.821276 26.8973561 306.088048 27.7971562 304.441482 26.7573872 304.521477 24.8044879 306.254705 23.9046878 307.901271 24.9444568"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "310.627772 27.1706287 309.421179 27.7971562 307.774612 26.7573872 307.854607 24.8044879 309.587835 23.9046878 310.627772 24.5645412"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "241.158664 30.8964675 239.425436 31.7962675 237.77887 30.7564986 237.858865 28.8035992 239.592093 27.9037992 241.238659 28.9435681"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "244.491795 30.8964675 242.758567 31.7962675 241.112 30.7564986 241.191996 28.8035992 242.925224 27.9037992 244.57179 28.9435681"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "247.824925 30.8964675 246.091698 31.7962675 244.445131 30.7564986 244.525126 28.8035992 246.258354 27.9037992 247.904921 28.9435681"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "251.158056 30.8964675 249.424828 31.7962675 247.778262 30.7564986 247.858257 28.8035992 249.591485 27.9037992 251.238051 28.9435681"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "254.491187 30.8964675 252.757959 31.7962675 251.111392 30.7564986 251.191387 28.8035992 252.924615 27.9037992 254.571182 28.9435681"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "257.824317 30.8964675 256.091089 31.7962675 254.444523 30.7564986 254.524518 28.8035992 256.257746 27.9037992 257.904312 28.9435681"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "261.157448 30.8964675 259.42422 31.7962675 257.777653 30.7564986 257.857649 28.8035992 259.590876 27.9037992 261.237443 28.9435681"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "264.490578 30.8964675 262.757351 31.7962675 261.110784 30.7564986 261.190779 28.8035992 262.924007 27.9037992 264.570574 28.9435681"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "267.823709 30.8964675 266.090481 31.7962675 264.443915 30.7564986 264.52391 28.8035992 266.257138 27.9037992 267.903704 28.9435681"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "271.15684 30.8964675 269.423612 31.7962675 267.777045 30.7564986 267.85704 28.8035992 269.590268 27.9037992 271.236835 28.9435681"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "274.48997 30.8964675 272.756742 31.7962675 271.110176 30.7564986 271.190171 28.8035992 272.923399 27.9037992 274.569965 28.9435681"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "277.823101 30.8964675 276.089873 31.7962675 274.443306 30.7564986 274.523302 28.8035992 276.256529 27.9037992 277.903096 28.9435681"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "281.156231 30.8964675 279.423003 31.7962675 277.776437 30.7564986 277.856432 28.8035992 279.58966 27.9037992 281.236227 28.9435681"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "284.489362 30.8964675 282.756134 31.7962675 281.109568 30.7564986 281.189563 28.8035992 282.922791 27.9037992 284.569357 28.9435681"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "287.822493 30.8964675 286.089265 31.7962675 284.442698 30.7564986 284.522693 28.8035992 286.255921 27.9037992 287.902488 28.9435681"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "291.155623 30.8964675 289.422395 31.7962675 287.775829 30.7564986 287.855824 28.8035992 289.589052 27.9037992 291.235618 28.9435681"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "294.488754 30.8964675 292.755526 31.7962675 291.108959 30.7564986 291.188954 28.8035992 292.922182 27.9037992 294.568749 28.9435681"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "297.821884 30.8964675 296.088656 31.7962675 294.44209 30.7564986 294.522085 28.8035992 296.255313 27.9037992 297.901879 28.9435681"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "301.155015 30.8964675 299.421787 31.7962675 297.77522 30.7564986 297.855216 28.8035992 299.588444 27.9037992 301.23501 28.9435681"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "304.488145 30.8964675 302.754918 31.7962675 301.108351 30.7564986 301.188346 28.8035992 302.921574 27.9037992 304.568141 28.9435681"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "307.821276 30.8964675 306.088048 31.7962675 304.441482 30.7564986 304.521477 28.8035992 306.254705 27.9037992 307.901271 28.9435681"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "310.627772 31.1697401 309.421179 31.7962675 307.774612 30.7564986 307.854607 28.8035992 309.587835 27.9037992 310.627772 28.5636525"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "241.158664 34.8955788 239.425436 35.7953788 237.77887 34.7556099 237.858865 32.8027105 239.592093 31.9029105 241.238659 32.9426794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "244.491795 34.8955788 242.758567 35.7953788 241.112 34.7556099 241.191996 32.8027105 242.925224 31.9029105 244.57179 32.9426794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "247.824925 34.8955788 246.091698 35.7953788 244.445131 34.7556099 244.525126 32.8027105 246.258354 31.9029105 247.904921 32.9426794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "251.158056 34.8955788 249.424828 35.7953788 247.778262 34.7556099 247.858257 32.8027105 249.591485 31.9029105 251.238051 32.9426794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "254.491187 34.8955788 252.757959 35.7953788 251.111392 34.7556099 251.191387 32.8027105 252.924615 31.9029105 254.571182 32.9426794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "257.824317 34.8955788 256.091089 35.7953788 254.444523 34.7556099 254.524518 32.8027105 256.257746 31.9029105 257.904312 32.9426794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "261.157448 34.8955788 259.42422 35.7953788 257.777653 34.7556099 257.857649 32.8027105 259.590876 31.9029105 261.237443 32.9426794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "264.490578 34.8955788 262.757351 35.7953788 261.110784 34.7556099 261.190779 32.8027105 262.924007 31.9029105 264.570574 32.9426794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "267.823709 34.8955788 266.090481 35.7953788 264.443915 34.7556099 264.52391 32.8027105 266.257138 31.9029105 267.903704 32.9426794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "271.15684 34.8955788 269.423612 35.7953788 267.777045 34.7556099 267.85704 32.8027105 269.590268 31.9029105 271.236835 32.9426794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "274.48997 34.8955788 272.756742 35.7953788 271.110176 34.7556099 271.190171 32.8027105 272.923399 31.9029105 274.569965 32.9426794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "277.823101 34.8955788 276.089873 35.7953788 274.443306 34.7556099 274.523302 32.8027105 276.256529 31.9029105 277.903096 32.9426794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "281.156231 34.8955788 279.423003 35.7953788 277.776437 34.7556099 277.856432 32.8027105 279.58966 31.9029105 281.236227 32.9426794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "284.489362 34.8955788 282.756134 35.7953788 281.109568 34.7556099 281.189563 32.8027105 282.922791 31.9029105 284.569357 32.9426794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "287.822493 34.8955788 286.089265 35.7953788 284.442698 34.7556099 284.522693 32.8027105 286.255921 31.9029105 287.902488 32.9426794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "291.155623 34.8955788 289.422395 35.7953788 287.775829 34.7556099 287.855824 32.8027105 289.589052 31.9029105 291.235618 32.9426794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "294.488754 34.8955788 292.755526 35.7953788 291.108959 34.7556099 291.188954 32.8027105 292.922182 31.9029105 294.568749 32.9426794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "297.821884 34.8955788 296.088656 35.7953788 294.44209 34.7556099 294.522085 32.8027105 296.255313 31.9029105 297.901879 32.9426794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "301.155015 34.8955788 299.421787 35.7953788 297.77522 34.7556099 297.855216 32.8027105 299.588444 31.9029105 301.23501 32.9426794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "304.488145 34.8955788 302.754918 35.7953788 301.108351 34.7556099 301.188346 32.8027105 302.921574 31.9029105 304.568141 32.9426794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "307.821276 34.8955788 306.088048 35.7953788 304.441482 34.7556099 304.521477 32.8027105 306.254705 31.9029105 307.901271 32.9426794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "310.627772 35.1688514 309.421179 35.7953788 307.774612 34.7556099 307.854607 32.8027105 309.587835 31.9029105 310.627772 32.5627638"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "241.158664 38.8946901 239.425436 39.7944901 237.77887 38.7547212 237.858865 36.8018218 239.592093 35.9020218 241.238659 36.9417907"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "244.491795 38.8946901 242.758567 39.7944901 241.112 38.7547212 241.191996 36.8018218 242.925224 35.9020218 244.57179 36.9417907"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "247.824925 38.8946901 246.091698 39.7944901 244.445131 38.7547212 244.525126 36.8018218 246.258354 35.9020218 247.904921 36.9417907"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "251.158056 38.8946901 249.424828 39.7944901 247.778262 38.7547212 247.858257 36.8018218 249.591485 35.9020218 251.238051 36.9417907"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "254.491187 38.8946901 252.757959 39.7944901 251.111392 38.7547212 251.191387 36.8018218 252.924615 35.9020218 254.571182 36.9417907"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "257.824317 38.8946901 256.091089 39.7944901 254.444523 38.7547212 254.524518 36.8018218 256.257746 35.9020218 257.904312 36.9417907"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "261.157448 38.8946901 259.42422 39.7944901 257.777653 38.7547212 257.857649 36.8018218 259.590876 35.9020218 261.237443 36.9417907"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "264.490578 38.8946901 262.757351 39.7944901 261.110784 38.7547212 261.190779 36.8018218 262.924007 35.9020218 264.570574 36.9417907"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "267.823709 38.8946901 266.090481 39.7944901 264.443915 38.7547212 264.52391 36.8018218 266.257138 35.9020218 267.903704 36.9417907"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "271.15684 38.8946901 269.423612 39.7944901 267.777045 38.7547212 267.85704 36.8018218 269.590268 35.9020218 271.236835 36.9417907"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "274.48997 38.8946901 272.756742 39.7944901 271.110176 38.7547212 271.190171 36.8018218 272.923399 35.9020218 274.569965 36.9417907"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "277.823101 38.8946901 276.089873 39.7944901 274.443306 38.7547212 274.523302 36.8018218 276.256529 35.9020218 277.903096 36.9417907"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "281.156231 38.8946901 279.423003 39.7944901 277.776437 38.7547212 277.856432 36.8018218 279.58966 35.9020218 281.236227 36.9417907"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "284.489362 38.8946901 282.756134 39.7944901 281.109568 38.7547212 281.189563 36.8018218 282.922791 35.9020218 284.569357 36.9417907"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "287.822493 38.8946901 286.089265 39.7944901 284.442698 38.7547212 284.522693 36.8018218 286.255921 35.9020218 287.902488 36.9417907"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "291.155623 38.8946901 289.422395 39.7944901 287.775829 38.7547212 287.855824 36.8018218 289.589052 35.9020218 291.235618 36.9417907"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "294.488754 38.8946901 292.755526 39.7944901 291.108959 38.7547212 291.188954 36.8018218 292.922182 35.9020218 294.568749 36.9417907"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "297.821884 38.8946901 296.088656 39.7944901 294.44209 38.7547212 294.522085 36.8018218 296.255313 35.9020218 297.901879 36.9417907"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "301.155015 38.8946901 299.421787 39.7944901 297.77522 38.7547212 297.855216 36.8018218 299.588444 35.9020218 301.23501 36.9417907"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "304.488145 38.8946901 302.754918 39.7944901 301.108351 38.7547212 301.188346 36.8018218 302.921574 35.9020218 304.568141 36.9417907"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "307.821276 38.8946901 306.088048 39.7944901 304.441482 38.7547212 304.521477 36.8018218 306.254705 35.9020218 307.901271 36.9417907"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "310.627772 39.1679627 309.421179 39.7944901 307.774612 38.7547212 307.854607 36.8018218 309.587835 35.9020218 310.627772 36.55521"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "241.158664 42.8938014 239.425436 43.7936014 237.77887 42.7538325 237.858865 40.8009331 239.592093 39.9011331 241.238659 40.940902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "244.491795 42.8938014 242.758567 43.7936014 241.112 42.7538325 241.191996 40.8009331 242.925224 39.9011331 244.57179 40.940902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "247.824925 42.8938014 246.091698 43.7936014 244.445131 42.7538325 244.525126 40.8009331 246.258354 39.9011331 247.904921 40.940902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "251.158056 42.8938014 249.424828 43.7936014 247.778262 42.7538325 247.858257 40.8009331 249.591485 39.9011331 251.238051 40.940902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "254.491187 42.8938014 252.757959 43.7936014 251.111392 42.7538325 251.191387 40.8009331 252.924615 39.9011331 254.571182 40.940902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "257.824317 42.8938014 256.091089 43.7936014 254.444523 42.7538325 254.524518 40.8009331 256.257746 39.9011331 257.904312 40.940902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "261.157448 42.8938014 259.42422 43.7936014 257.777653 42.7538325 257.857649 40.8009331 259.590876 39.9011331 261.237443 40.940902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "264.490578 42.8938014 262.757351 43.7936014 261.110784 42.7538325 261.190779 40.8009331 262.924007 39.9011331 264.570574 40.940902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "267.823709 42.8938014 266.090481 43.7936014 264.443915 42.7538325 264.52391 40.8009331 266.257138 39.9011331 267.903704 40.940902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "271.15684 42.8938014 269.423612 43.7936014 267.777045 42.7538325 267.85704 40.8009331 269.590268 39.9011331 271.236835 40.940902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "274.48997 42.8938014 272.756742 43.7936014 271.110176 42.7538325 271.190171 40.8009331 272.923399 39.9011331 274.569965 40.940902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "277.823101 42.8938014 276.089873 43.7936014 274.443306 42.7538325 274.523302 40.8009331 276.256529 39.9011331 277.903096 40.940902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "281.156231 42.8938014 279.423003 43.7936014 277.776437 42.7538325 277.856432 40.8009331 279.58966 39.9011331 281.236227 40.940902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "284.489362 42.8938014 282.756134 43.7936014 281.109568 42.7538325 281.189563 40.8009331 282.922791 39.9011331 284.569357 40.940902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "287.822493 42.8938014 286.089265 43.7936014 284.442698 42.7538325 284.522693 40.8009331 286.255921 39.9011331 287.902488 40.940902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "291.155623 42.8938014 289.422395 43.7936014 287.775829 42.7538325 287.855824 40.8009331 289.589052 39.9011331 291.235618 40.940902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "294.488754 42.8938014 292.755526 43.7936014 291.108959 42.7538325 291.188954 40.8009331 292.922182 39.9011331 294.568749 40.940902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "297.821884 42.8938014 296.088656 43.7936014 294.44209 42.7538325 294.522085 40.8009331 296.255313 39.9011331 297.901879 40.940902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "301.155015 42.8938014 299.421787 43.7936014 297.77522 42.7538325 297.855216 40.8009331 299.588444 39.9011331 301.23501 40.940902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "304.488145 42.8938014 302.754918 43.7936014 301.108351 42.7538325 301.188346 40.8009331 302.921574 39.9011331 304.568141 40.940902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "307.821276 42.8938014 306.088048 43.7936014 304.441482 42.7538325 304.521477 40.8009331 306.254705 39.9011331 307.901271 40.940902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.15,
    points: "310.627772 43.167074 309.421179 43.7936014 307.774612 42.7538325 307.854607 40.8009331 309.587835 39.9011331 310.627772 40.5543213"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 273.323374,
    cy: 63.5825372,
    rx: 1.35991728,
    ry: 1.35969784
  })), /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 253.5,
    x2: 497,
    y2: 253.5,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootballFieldMobile);
export default __webpack_public_path__ + "static/media/football-field-mobile.accad202fa76b3a3fab7e25b2c275077.svg";
export { ForwardRef as ReactComponent };